export enum DocumentProcessToStatusGrid {
    Pending,
    Signed,
    Declined,
    ReadOnly,
    Received
    
}

export const DocumentProcessToStatusGridTranslate = new Map<number, string>([
    [DocumentProcessToStatusGrid.Pending, "documentProcessToStatusGrid.Pending"],
    [DocumentProcessToStatusGrid.Signed, "documentProcessToStatusGrid.Signed"],
    [DocumentProcessToStatusGrid.ReadOnly, "documentProcessToStatusGrid.ReadOnly"],
    [DocumentProcessToStatusGrid.Declined, "documentProcessToStatusGrid.Declined"],
    [DocumentProcessToStatusGrid.Received, "documentProcessToStatusGrid.Received"]
]);